import { Injectable, signal } from "@angular/core";
import { Subject } from "rxjs";
export enum ViewType {
    All = "all",
    Active = "active",
    Completed = "completed",
    NotStarted = "notStarted",
}
@Injectable({ providedIn: "root" })
export class CardViewService {
    public viewTypeChangeSubject = new Subject<ViewType | null>();
    viewTypeChangeEvent$ = this.viewTypeChangeSubject.asObservable();
    public viewDisplayModeChangeSubject = new Subject<string>();
    viewDisplayModeChangeEvent$ = this.viewDisplayModeChangeSubject.asObservable();
    public assigneesStatusChangeSubject = new Subject<{ stepId; statusId }>();
    public refreshCardsViewLabelsSubject = new Subject<boolean>();
    refreshCardsViewLabelsEvent$ = this.refreshCardsViewLabelsSubject.asObservable();
    currentViewDisplayMode: "Kanban" | "details" | "List" = "Kanban";
    sCurrentViewDisplayMode = signal<"Kanban" | "details" | "List">("Kanban");
    currentViewType: ViewType | null = null;
    sCurrentViewType = signal<ViewType | null>(null);
    settingsSectionChanged = false;
    selectedStepId: string;
    public isAllCardsDownloaded: boolean;

    setCurrentViewType(type: ViewType | null) {
        this.currentViewType = type;
        this.sCurrentViewType.set(type);
        // Emit change
        this.viewTypeChangeSubject.next(type);
    }
    setCurrentViewDisplayMode(type: "Kanban" | "details" | "List") {
        this.currentViewDisplayMode = type;
        this.sCurrentViewDisplayMode.set(type);
        // Emit change
        this.viewDisplayModeChangeSubject.next(type);
    }
}
